import './polifill'
import Vue from 'vue'
import './config'
import './const'
import './directive'
import './filter'
import './validator'

import Plugins from './plugins'
import router from './router'
import store from './store'
import './appCallFunction'

import App from './components/App'
import { saveUtmAndReferral } from './router/_interceptor/utm'
import qs from 'query-string'

Vue.config.productionTip = false

const init = async () => {
  // 최초 셋팅
  try {
    await store.dispatch('auth/init')
  } finally {
    // 메인 페이지 + 비인증 시 리다이렉트
    if (window.location.pathname === '/' && !store.getters['auth/isAuthenticated']) {
      const landingUrl = process.env.common?.landingUrl
      if (landingUrl) {
        // UTM 파라미터를 쿠키에 저장
        const query = qs.parse(window.location.search)
        saveUtmAndReferral(query)

        // landingUrl에 쿼리 파라미터 추가 (GTM 추적용)
        const targetUrl = new URL(landingUrl)
        targetUrl.search = window.location.search

        window.location.replace(targetUrl.toString())
      }
    } else {
      // 인증되었거나 메인 페이지가 아닌 경우 앱 마운트
      global.$vm = new Vue({
        router,
        store,
        vuetify: Plugins.vuetify,
        render: (h) => h(App),
      }).$mount('#app')
      global.$vm.$gtm.trackEvent({ event: 'init-app' })
    }
  }
}
init()
